export const getPixKeyMask = (tipoChavePix) => {
  if (tipoChavePix === 'CPF') return '999.999.999-99';
  if (tipoChavePix === 'CNPJ') return '99.999.999/9999-99';
  if (tipoChavePix === 'Telefone') return '(99) 99999-9999';
  return null;
};

export const sanitizePixKey = (value) => {
  if (!value) return '';
  return value.replace(/[^\d]/g, '');
};


